var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20667 5C7.26667 5.89 7.41667 6.76 7.65667 7.59L6.45667 8.79C6.04667 7.59 5.78667 6.32 5.69667 5H7.20667ZM17.0667 17.02C17.9167 17.26 18.7867 17.41 19.6667 17.47V18.96C18.3467 18.87 17.0767 18.61 15.8667 18.21L17.0667 17.02ZM8.16667 3H4.66667C4.11667 3 3.66667 3.45 3.66667 4C3.66667 13.39 11.2767 21 20.6667 21C21.2167 21 21.6667 20.55 21.6667 20V16.51C21.6667 15.96 21.2167 15.51 20.6667 15.51C19.4267 15.51 18.2167 15.31 17.0967 14.94C16.9967 14.9 16.8867 14.89 16.7867 14.89C16.5267 14.89 16.2767 14.99 16.0767 15.18L13.8767 17.38C11.0467 15.93 8.72667 13.62 7.28667 10.79L9.48667 8.59C9.76667 8.31 9.84667 7.92 9.73667 7.57C9.36667 6.45 9.16667 5.25 9.16667 4C9.16667 3.45 8.71667 3 8.16667 3Z",
    fill: "#47D316"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.cc2c24391989ac17fb95112252ca4add.svg";
export { ForwardRef as ReactComponent };